import { render, staticRenderFns } from "./showItemForm.vue?vue&type=template&id=0080212e&scoped=true&"
import script from "./showItemForm.vue?vue&type=script&lang=js&"
export * from "./showItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080212e",
  null
  
)

export default component.exports